var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSupportNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.4546C14.928 10.4546 10 15.3826 10 21.4546C10 27.5266 14.928 32.4546 21 32.4546C27.072 32.4546 32 27.5266 32 21.4546C32 15.3826 27.072 10.4546 21 10.4546ZM22.1 29.1546H19.9V26.9546H22.1V29.1546ZM24.377 20.6296L23.387 21.6416C22.595 22.4446 22.1 23.1046 22.1 24.7546H19.9V24.2046C19.9 22.9946 20.395 21.8946 21.187 21.0916L22.551 19.7056C22.958 19.3096 23.2 18.7596 23.2 18.1546C23.2 16.9446 22.21 15.9546 21 15.9546C19.79 15.9546 18.8 16.9446 18.8 18.1546H16.6C16.6 15.7236 18.569 13.7546 21 13.7546C23.431 13.7546 25.4 15.7236 25.4 18.1546C25.4 19.1226 25.004 20.0026 24.377 20.6296Z",
    fill: "#909090"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportNew);
export default __webpack_public_path__ + "static/media/support-new.9441d6bbbd0db66f92597a248bd197d0.svg";
export { ForwardRef as ReactComponent };